module.exports = __webpack_public_path__ + "img/full2-min.f8b3ffc5.png";